import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';
const USE_API = process.env.REACT_APP_USE_API === 'true';

const getCSRFToken = () => {
  return document.cookie
    .split("; ")
    .find((row) => row.startsWith("csrftoken="))
    ?.split("=")[1];
};

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 5000, // Reducido de 10s a 5s para fallar más rápido
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

apiClient.interceptors.request.use(
  (config) => {
    const csrfToken = getCSRFToken();
    if (csrfToken && (config.method === 'post' || config.method === 'put' || config.method === 'patch' || config.method === 'delete')) {
      config.headers['X-CSRFToken'] = csrfToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores globalmente
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Solo mostrar errores si no son timeouts o errores de conexión
    if (error.code !== 'ECONNABORTED' && error.code !== 'ECONNREFUSED') {
      console.error('API Error:', error);
    }
    return Promise.reject(error);
  }
);

// Función helper para verificar si debe usar API real
export const shouldUseAPI = () => USE_API;

// Función helper para manejar errores de API
export const handleAPIError = (error) => {
  if (USE_API) {
    // Log detallado del error para debugging
    console.log('API Error Details:', {
      status: error.response?.status,
      data: error.response?.data,
      headers: error.response?.headers
    });
    
    // En modo API real, propagar errores claros
    if (error.response?.status === 400) {
      return {
        type: 'validation',
        message: 'Datos inválidos: ' + JSON.stringify(error.response.data),
        errors: error.response.data || {}
      };
    }
    if (error.response?.status === 422) {
      return {
        type: 'validation',
        errors: error.response.data.errors || {}
      };
    }
    if (error.response?.status === 500) {
      return {
        type: 'server',
        message: 'Error interno del servidor. Intente nuevamente.'
      };
    }
    if (error.response?.status === 403) {
      return {
        type: 'auth',
        message: 'No tiene permisos para realizar esta acción.'
      };
    }
    if (error.response?.status === 404) {
      return {
        type: 'not_found',
        message: 'Recurso no encontrado.'
      };
    }
    return {
      type: 'network',
      message: 'Error de conexión. Verifique su conexión a internet.'
    };
  }
  // En modo mock, no propagar errores
  return null;
};

export default apiClient;
